import React from 'react';
import { PaymentMethodLayout } from './view';
import { StoreState } from '../../../../types/ReduxMisc';
import { selectDeviceType } from '../../../../redux/selectors';
import { connect } from 'react-redux';

const mapStateToProps = (store: StoreState) => ({
  deviceType: selectDeviceType(store),
});

type ComponentProps = React.ComponentProps<typeof PaymentMethodLayout>;
type StateProps = ReturnType<typeof mapStateToProps>;
type OwnProps = Omit<ComponentProps, keyof StateProps>;

export const PaymentMethodLayoutConnect =
  connect<StateProps, {}, OwnProps>(mapStateToProps)(PaymentMethodLayout);
